// extracted by mini-css-extract-plugin
module.exports = {"root":"CreditOrdersSummaryTableRow_root__2DHoD","progress-value":"CreditOrdersSummaryTableRow_progress-value__2r67_"};